export interface IConnection {
  id: string
  areaInterest: string
  createdAt: string
  description: string
  responsible: string
  source: string
  updatedAt: string
}

export interface IPublicAdministrationAddress {
  name?: string
  lineOne?: string
  lineTwo?: string
  number?: string
  zipcode?: string
  neighborhood?: string
  city?: string
  state?: string
  country?: string
}

export interface IPublicAdministrationInfo {
  id?: string
  companyId?: string
  administrationName?: string
  administrationType?: number | null
  administrationDescription?: string
  address?: IPublicAdministrationAddress
  populationSize?: number | null
  estimatedAnnualBudget?: number | null
  numberEmployers?: number | null
  cnpj?: string | null
  leadership?: Record<string, unknown>
  innovationProfile?: Record<string, unknown>
  focalPoints?: unknown[] | null
}

/** Item de linha nas listagens POST .../public-administration e .../resident */
export interface IPublicAdministrationEcosystemRow {
  publicAdministrationInfo?: IPublicAdministrationInfo | null
  profileImage?: string | null
  residentId?: string | null
  resident_id?: string | null
  connections?: IConnection[]
  ecosystemHidden?: boolean | null
}

export interface IPublicAdministrationListResponse {
  rows: IPublicAdministrationEcosystemRow[]
  totalRows: number
  totalPages?: number
  offset?: number
  limit?: number
}

export interface IStartup {
  id: string
  companyId?: string
  companyName: string
  createdAt?: string
  companyContactName: string
  companyEmailContact: string
  companyContactPhone: string
  companyContactMobile: string
  companyCNPJ: string
  companyWebsite: string
  profileImage: string | null
  address: {
    lineOne: string
    lineTwo: string
    number: string
    zipcode: string
    neighborhood: string
    city: string
    state: string
    country: string
  }
  startupInfo: {
    id: string
    businessModel: string
    numberEmployees: string
    technologies: string
    pitch: string
    developmentStage: number
    annualTurnover: number
    hasRaisedInvestment: boolean
    amount: number
    investmentSource: string
    activity: string
    target?: string
  }
  resident_id: string | null
  connections?: IConnection[]
  ecosystemHidden?: boolean | null
}

export interface DateRange {
  start: Date | null
  end: Date | null
}

export interface FilterItem {
  field: string
  condition: string
  comparison: string
}

export const ecosystemStartupResidentCompanyId = (startup: IStartup): string => {
  const c = startup.companyId?.trim()
  return c !== undefined && c !== '' ? c : startup.id
}
